import { styled } from '@linaria/react';
import { Card, Flex, Stack } from '@mantine/core';
import { FC } from 'react';
import i18n from '../../../base-dictionary';
import { secondaryBase } from '../../../styles/design-tokens';
import { Icon } from '../../../ui-library/icon/icon';
import { Text } from '../../../ui-library/typography/typography';

interface DashboardInfoCardProps {
  title: string;
  objectName: string;
  description?: string;
  iconName?: string;
}

export const DashboardInfoCard: FC<DashboardInfoCardProps> = ({
  title,
  objectName,
  description,
  iconName = 'dashboard',
}) => {
  const defaultDescription = `Try changing your global ${i18n.t('common.portfolio').toLowerCase()} or select a different ${objectName.toLowerCase()}.`;

  return (
    <StyledWrapper>
      <StyledCard
        shadow="sm"
        padding="xl"
        radius="md"
        withBorder
        style={{
          width: '416px',
          height: '240px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
        }}
      >
        <Stack align="center" gap="md">
          <Icon name={iconName} variant="outlined" size={40} color={secondaryBase} />
          <Text weight="medium" size="large">
            {title}
          </Text>
          <Text style={{ textAlign: 'center' }}>{description || defaultDescription}</Text>
        </Stack>
      </StyledCard>
    </StyledWrapper>
  );
};

const StyledWrapper = styled(Flex)`
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 250px);
  width: 100%;
`;

const StyledCard = styled(Card)`
  width: 416px;
  height: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
`;
